(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         *
         */
        .controller('TeamDetailsCtrl', ['$scope', '$q', '$stateParams', '$state', '$uibModal', 'jwtService', 'teamSettingsService', 'facebookService', 'usersService', 'inboundService', 'customChannelService', 'sweetAlertService', 'growlService', 'team', 'chatConfig', 'uploadFileService', 'twitterServices', 'channelsProvider', 'whatsAppServices', 'permissionService', 'rcsServices',
            function ($scope, $q, $stateParams, $state, $uibModal, jwtService, teamSettingsService, facebookService, usersService, inboundService, customChannelService, sweetAlertService, growlService, team, chatConfig, uploadFileService, twitterServices, channelsProvider, whatsAppServices, permissionService, rcsServices) {

                $scope.permissionConfig = permissionService.checkPermission('chat:cfg:w');
                $scope.id = $stateParams.pickedApiSpaceId;
                var teamId = $stateParams.teamId;
                $scope.accountId = jwtService.payload.accountId;
                $scope.settings = {};
                $scope.select = {};
                $scope.selected = {
                    members: [],
                    settings: {
                        closeMessageIsActive: false,
                        workingHours: [
                            {
                                days: '',
                                from: '',
                                to: ''
                            }
                        ]
                    }
                };


                $scope.form = {
                    days: [
                        {
                            value: 'Monday',
                            label: 'Monday'
                        },
                        {
                            value: 'Tuesday',
                            label: 'Tuesday'
                        },
                        {
                            value: 'Wednesday',
                            label: 'Wednesday'
                        },
                        {
                            value: 'Thursday',
                            label: 'Thursday'
                        },
                        {
                            value: 'Friday',
                            label: 'Friday'
                        },
                        {
                            value: 'Saturday',
                            label: 'Saturday'
                        },
                        {
                            value: 'Sunday',
                            label: 'Sunday'
                        },
                        {
                            value: 'Monday to Friday',
                            label: 'Mon to Fri'
                        },
                        {
                            value: 'Weekend',
                            label: 'Weekend'
                        }]
                };

                $scope.channelMap = [
                    {
                        orderNo: 0,
                        name: channelsProvider.sms.name,
                        id: "sms",
                        link: "main.apiSpace.chat2.settings.team.config({channel:'sms'})",
                        disable: disableSms,
                        activated: false
                    },
                    {
                        orderNo: 1,
                        name: channelsProvider.fbMessenger.name,
                        id: "fbMessenger",
                        link: "main.apiSpace.chat2.settings.team.config({channel:'fbMessenger'})",
                        disable: disableFb,
                        activated: false
                    },
                    {
                        orderNo: 2,
                        name: "Web chat",
                        id: "appMessaging",
                        link: "main.apiSpace.chat2.settings.team.config({channel:'appMessaging'})",
                        disable: disableAppMessaging,
                        activated: false
                    },
                    {
                        orderNo: 3,
                        name: channelsProvider.email.name,
                        id: "email",
                        link: "main.apiSpace.chat2.settings.team.config({channel:'email'})",
                        disable: disableEmail,
                        activated: false
                    },
                    {
                        orderNo: 4,
                        name: channelsProvider.twitterDm.name,
                        id: "twitterDm",
                        link: "main.apiSpace.chat2.settings.team.config({channel:'twitter'})",
                        disable: disableTwitter,
                        activated: false
                    },
                    {
                        orderNo: 5,
                        name: channelsProvider.whatsApp.name,
                        id: "whatsApp",
                        link: "main.apiSpace.chat2.settings.team.config({channel:'whatsApp'})",
                        disable: disableWhatsApp,
                        activated: false
                    },
                    {
                        orderNo: 6,
                        name: channelsProvider.rcs.name,
                        id: "rcs",
                        link: "main.apiSpace.chat2.settings.team.config({channel:'rcs'})",
                        disable: disableRcs,
                        activated: false
                    }
                ];


                $scope.openConfig = function openConfig(channelId) {
                    switch (channelId) {
                        case 'sms':
                            $uibModal.open({
                                templateUrl: 'components/toolkit/chat/templates/channelConfigModals/smsConfigModal.html',
                                size: 'md',
                                resolve: {
                                    currentChannel: function () { return channelId; },
                                    chatConfig: function () { return chatConfig; },
                                    inboundNo: function () {
                                        return inboundService.getDedicatedNumbers($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noInboundNo';
                                                }
                                            }
                                        );
                                    },
                                    fb: function () { return false; },
                                    channels: function () {
                                        return customChannelService.getChannels($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noChannels';
                                                }
                                            });
                                    },
                                    twitter: function () {
                                        return false;
                                    },
                                    whatsApp: function () {
                                        return [];
                                    },
                                    hsms: function () {
                                        return [];
                                    },
                                    rcs: function () {
                                        return [];
                                    }
                                },
                                controller: 'chatConfigCtrl'
                            });
                            break;
                        case 'fbMessenger':
                            $uibModal.open({
                                templateUrl: 'components/toolkit/chat/templates/channelConfigModals/fbConfigModal.html',
                                size: 'md',
                                resolve: {
                                    currentChannel: function () { return channelId; },
                                    chatConfig: function () { return chatConfig; },
                                    inboundNo: function () { return false; },
                                    fb: function () {
                                        return facebookService.getPageFromComapi($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noFacebookId';
                                                }
                                            });
                                    },
                                    channels: function () {
                                        return customChannelService.getChannels($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noChannels';
                                                }
                                            });
                                    },
                                    twitter: function () {
                                        return false;
                                    },
                                    whatsApp: function () {
                                        return [];
                                    },
                                    hsms: function () {
                                        return [];
                                    },
                                    rcs: function () {
                                        return [];
                                    }
                                },
                                controller: 'chatConfigCtrl'
                            });
                            break;
                        case 'appMessaging':
                            $uibModal.open({
                                templateUrl: 'components/toolkit/chat/templates/channelConfigModals/webChatConfigModal.html',
                                size: 'lg',
                                resolve: {
                                    currentChannel: function () { return channelId; },
                                    chatConfig: function () { return chatConfig; },
                                    inboundNo: function () { return false; },
                                    fb: function () { return false; },
                                    channels: function () {
                                        return customChannelService.getChannels($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noChannels';
                                                }
                                            });
                                    },
                                    twitter: function () {
                                        return false;
                                    },
                                    whatsApp: function () {
                                        return [];
                                    },
                                    hsms: function () {
                                        return [];
                                    },
                                    rcs: function () {
                                        return [];
                                    }
                                },
                                controller: 'chatConfigCtrl'
                            });
                            break;
                        case 'email':
                            $uibModal.open({
                                templateUrl: 'components/toolkit/chat/templates/channelConfigModals/emailConfigModal.html',
                                size: 'md',
                                resolve: {
                                    currentChannel: function () { return channelId; },
                                    chatConfig: function () { return chatConfig; },
                                    inboundNo: function () { return false; },
                                    fb: function () { return false; },
                                    channels: function () {
                                        return customChannelService.getChannels($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noChannels';
                                                }
                                            });
                                    },
                                    twitter: function () {
                                        return false;
                                    },
                                    whatsApp: function () {
                                        return [];
                                    },
                                    hsms: function () {
                                        return [];
                                    },
                                    rcs: function () {
                                        return [];
                                    }
                                },
                                controller: 'chatConfigCtrl'
                            });
                            break;
                        case 'twitterDm':
                            $uibModal.open({
                                templateUrl: 'components/toolkit/chat/templates/channelConfigModals/twitterConfigModal.html',
                                size: 'md',
                                resolve: {
                                    currentChannel: function () { return channelId; },
                                    chatConfig: function () { return chatConfig; },
                                    inboundNo: function () { return false; },
                                    fb: function () { return false; },
                                    channels: function () {
                                        return customChannelService.getChannels($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noChannels';
                                                }
                                            });
                                    },
                                    twitter: function () {
                                        return twitterServices.getTwitterDetails($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(function (error) {
                                            if (error.status === 404) {
                                                return 'noTwitter';
                                            }
                                        });
                                    },
                                    whatsApp: function () {
                                        return [];
                                    },
                                    hsms: function () {
                                        return [];
                                    },
                                    rcs: function () {
                                        return [];
                                    }
                                },
                                controller: 'chatConfigCtrl'
                            });
                            break;

                        case 'whatsApp':
                            $uibModal.open({
                                templateUrl: 'components/toolkit/chat/templates/channelConfigModals/whatsAppConfigModal.html',
                                size: 'md',
                                resolve: {
                                    currentChannel: function () { return channelId; },
                                    chatConfig: function () { return chatConfig; },
                                    inboundNo: function () { return false; },
                                    fb: function () { return false; },
                                    channels: function () {
                                        return customChannelService.getChannels($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noChannels';
                                                }
                                            });
                                    },
                                    twitter: function () {
                                        return {};
                                    },
                                    whatsApp: async function () {
                                        try {
                                            const cloudData = await whatsAppServices.getSuccessfulWhatsAppCloudConfigurations($state.toParams.pickedApiSpaceId);
                                            if (cloudData.length > 0) {
                                                return cloudData;
                                            }

                                            return await whatsAppServices.getAllWhatsAppConfigurations($state.toParams.pickedApiSpaceId);
                                        } catch (error) {
                                            if (error.status === 404) {
                                                return 'noConfig';
                                            }
                                        }
                                    },
                                    hsms: function () {
                                        return whatsAppServices.getHsms($state.toParams.pickedApiSpaceId).then(
                                            function (data) {
                                                return data;
                                            }).catch(
                                                function (error) {
                                                    if (error.status === 404) {
                                                        return [];
                                                    }
                                                });
                                    },
                                    rcs: function () {
                                        return [];
                                    }
                                },
                                controller: 'chatConfigCtrl'
                            });
                            break;

                        case 'rcs':
                            $uibModal.open({
                                templateUrl: 'components/toolkit/chat/templates/channelConfigModals/rcsConfigModal.html',
                                size: 'md',
                                resolve: {
                                    currentChannel: function () { return channelId; },
                                    chatConfig: function () { return chatConfig; },
                                    inboundNo: function () { return false; },
                                    fb: function () { return false; },
                                    channels: function () {
                                        return customChannelService.getChannels($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noChannels';
                                                }
                                            });
                                    },
                                    rcs: function () {
                                        return rcsServices.getAllRcsConfigurations($state.toParams.pickedApiSpaceId).then(function (data) {
                                            return data;
                                        }).catch(
                                            function (error) {
                                                if (error.status === 404) {
                                                    return 'noConfig';
                                                }
                                            });
                                    },
                                    twitter: function () {
                                        return {};
                                    },
                                    whatsApp: function () {
                                        return [];
                                    },
                                    hsms: function () {
                                        return [];
                                    }
                                },
                                controller: 'chatConfigCtrl'
                            });
                            break;
                    }
                };



                if (team) {
                    processTeam(team);
                }
                getUsers($scope.accountId);
                processChatConfigComplete(chatConfig);

                // .then(processChatConfigComplete)
                // .catch(function (error) {
                //     if (error.status !== 404) {
                //         growlService.danger("Chat settings were not available due to: " + error.statusText);
                //     }
                // });
                // getChatConfig();

                $scope.$on('ChannelsCountChange', function (event, message) {
                    getChatConfig();
                });

                $scope.addImage = function () {
                    uploadFileService.uploadFile().then(function (result) {
                        $scope.selected.settings.avatarUrl = result.url;
                        $scope.updateChatConfig();
                    });
                };

                $scope.updateTeamName = function (newTeamName) {
                    if (newTeamName) {
                        var data = {
                            name: newTeamName
                        };
                        teamSettingsService.updateTeam($stateParams.pickedApiSpaceId, $stateParams.teamId, data)
                            .then(function () {
                                $scope.$emit("teamNameChanged", { teamId: teamId, teamName: newTeamName });
                            }
                            )
                            .catch(function (error) {
                                growlService.danger("Team name was not updated due to: " + error.statusText);
                            });
                    }
                };

                function getChatConfig() {
                    teamSettingsService.getChatConfig($scope.id)
                        .then(processChatConfigComplete)
                        .catch(function (error) {
                            if (error.status !== 404) {
                                growlService.danger("Chat settings were not available due to: " + error.statusText);
                            }
                        });
                }

                function processChatConfigComplete(data) {
                    chatConfig = data;
                    if (data.teams) {
                        var currentTeamConfig = data.teams.find(function (el) {
                            return el.teamId == teamId;
                        });
                        if (currentTeamConfig) {
                            processChannels(currentTeamConfig);
                            processSettings(currentTeamConfig);
                        } else {
                            $scope.channelMap.forEach(function (channel) {
                                channel.activated = false;
                            });
                        }

                    } else {
                        $scope.channelMap.forEach(function (channel) {
                            channel.activated = false;
                        });
                    }
                }

                function processChannels(currentTeamConfig) {
                    $scope.channelMap.forEach(function (channel) {
                        channel.activated = false;
                    });
                    if (currentTeamConfig.channels) {
                        (Object.keys(currentTeamConfig.channels)).forEach(function (channel) {
                            if (Object.keys(currentTeamConfig.channels[channel]) && Object.keys(currentTeamConfig.channels[channel]).length > 0) {
                                var channelInMap = $scope.channelMap.find(function (el) {
                                    return el.id == channel;
                                });
                                channelInMap.activated = true;
                            }
                        });
                    }

                }

                function processSettings(currentTeamConfig) {
                    if (currentTeamConfig.settings) {
                        $scope.settings = currentTeamConfig.settings;
                        $scope.selected.settings.outOfHoursMessageEnabled = currentTeamConfig.settings.outOfHoursMessageEnabled || false;
                        if (currentTeamConfig.settings.avatarUrl) {
                            $scope.selected.settings.avatarUrl = currentTeamConfig.settings.avatarUrl;
                        }
                        if (currentTeamConfig.settings.closeMessage) {
                            $scope.selected.settings.closeMessage = currentTeamConfig.settings.closeMessage;
                            $scope.selected.settings.closeMessageIsActive = true;
                        }
                        if (currentTeamConfig.settings.outOfHoursMessage) {
                            $scope.selected.settings.outOfHoursMessage = currentTeamConfig.settings.outOfHoursMessage;
                        }
                        if (currentTeamConfig.settings.outOfHoursFormTemplateId && currentTeamConfig.settings.outOfHoursFormTemplateId.length > 0) {
                            $scope.selected.settings.outOfHoursFormIsActive = true;
                        }
                        if (currentTeamConfig.settings.workingHours) {
                            $scope.selected.settings.workingHours = currentTeamConfig.settings.workingHours;
                            currentTeamConfig.settings.workingHours.forEach(function (workingHours, index) {
                                if (workingHours.from == '00:00' && workingHours.to == '23:59') {
                                    $scope.selected.settings.workingHours[index].from = 'All day';
                                    $scope.selected.settings.workingHours[index].to = '';
                                } else {
                                    workingHours.from = timeFromString(workingHours.from);
                                    workingHours.to = timeFromString(workingHours.to);
                                }
                            });
                        }
                    }
                }

                $scope.chatSettingsChanges = function () {
                    if (!$scope.selected.settings.closeMessageIsActive) {
                        $scope.selected.settings.closeMessage = '';
                        $scope.settings = {
                            closeMessage: ''
                        };
                    }
                };

                $scope.outOfHoursFormChanges = function () {
                    if ($scope.selected.settings.outOfHoursFormIsActive) {
                        $scope.selected.settings.outOfHoursMessage = '';
                        $scope.settings = {
                            outOfHoursMessage: ''
                        };
                    }
                };

                function timeToString(date) {
                    if (date) {
                        var minutes = date.minutes();
                        if (minutes < 10) {
                            minutes = '0' + minutes;
                        }
                        return date.hour() + ":" + minutes;
                    }
                }

                function timeFromString(date) {
                    return moment('1970-01-01 ' + date, 'YYYY-MM-DD HH:mm');
                }

                $scope.updateChatConfig = function updateChatConfig() {
                    $scope.chatSettingsChanges();
                    if ($scope.selected.settings.closeMessageIsActive && !$scope.selected.settings.closeMessage) {
                        return false;
                    }
                    var data = {
                        avatarUrl: $scope.selected.settings.avatarUrl || '',
                        closeMessage: $scope.selected.settings.closeMessage || '',
                        outOfHoursMessage: $scope.selected.settings.outOfHoursMessage || '',
                        workingHours: angular.copy($scope.selected.settings.workingHours),
                        outOfHoursMessageEnabled: $scope.selected.settings.outOfHoursMessageEnabled
                    };

                    if ($scope.selected.settings.outOfHoursFormIsActive) {
                        data.outOfHoursFormTemplateId = 'outOfHours';
                        $scope.selected.settings.outOfHoursMessage = '';
                    }

                    var valid = true;
                    data.workingHours.forEach(function (workingHours, index) {
                        if ((workingHours.days.length > 0 || workingHours.from._isAMomentObject || workingHours.to._isAMomentObject) && !(workingHours.days.length > 0 && workingHours.from._isAMomentObject && workingHours.to._isAMomentObject)) {
                            valid = false;
                            growlService.danger("You need to fill in all fields in working hours definition");
                            return false;
                        }
                        if (workingHours.from == 'All day') {
                            workingHours.from = '00:00';
                            workingHours.to = '23:59';
                        } else if (workingHours.from.length > 0 &&
                            (workingHours.to.length == 0 || workingHours.days.length == 0)) {
                            return growlService.danger("You need to fill in all fields in working hours definition");
                        } else {
                            workingHours.from = timeToString(workingHours.from);
                            workingHours.to = timeToString(workingHours.to);
                        }
                        if (workingHours.days.length === 0 || workingHours.from.length === 0 || workingHours.to.length === 0) {
                            return data.workingHours.splice(index);
                        }
                    });


                    if (data.workingHours.length === 0) {
                        delete data.workingHours;
                    } else if ($scope.selected.settings.outOfHoursMessageEnabled && data.outOfHoursMessage.length === 0) {
                        valid = false;
                        growlService.danger("You need to add out of hours message");
                        return false;
                    }

                    if (data.avatarUrl.length === 0) {
                        delete data.avatarUrl;
                    }
                    if (data.closeMessage.length === 0) {
                        delete data.closeMessage;
                    }
                    if (data.outOfHoursMessage.length === 0) {
                        delete data.outOfHoursMessage;
                    }

                    if (valid) {
                        teamSettingsService.updateSettings($scope.id, teamId, data)
                            .then(function onSuccess(result) {
                                growlService.success("Chat settings were succesfully updated");
                                $scope.$emit("WorkingHoursChange", result);
                                processChatConfigComplete(result);
                            }
                            )
                            .catch(function (error) {
                                growlService.danger("Chat settings were not updated due to: " + error.statusText);
                            });
                    }

                };

                $scope.assessChanges = function assessChanges(model, input) {

                    var mappedModel = model.map(toString);
                    var mappedInput = input.map(toString);

                    if (model.length < input.length) {
                        var newMemberArray = findDiff(mappedModel, mappedInput);
                        return addTeamMember(newMemberArray[0]).then(
                            function onSuccess() {
                                growlService.success("Team member was succesfully added");
                            }
                        ).catch(
                            function (error) {
                                growlService.danger("Team member was not added due to: " + error.statusText);
                            }
                        );
                    } else if (!input.length || model.length > input.length) {
                        var removedMemberArray = findDiff(mappedModel, mappedInput);
                        return deleteTeamMember(removedMemberArray[0]).then(
                            function onSuccess() {
                                growlService.success("Team member was succesfully removed");
                            }
                        ).catch(
                            function (error) {
                                growlService.danger("Team member was not removed due to: " + error.statusText);
                            }
                        );
                    }

                    return $q.resolve();

                    function toString(el) {
                        return el.username;
                    }

                    function findDiff(array1, array2) {
                        if (array2.length > array1.length) {
                            return array2.filter(function (el) { return array1.indexOf(el) < 0; });
                        }
                        else {
                            return array1.filter(function (el) { return array2.indexOf(el) < 0; });
                        }
                    }
                };

                $scope.deleteTeam = function (teamId) {

                    sweetAlertService.confirmationAlert(
                        "Are you sure?",
                        "Are you sure you want to remove " + $scope.team.name + "?",
                        "Remove Team",
                        "Cancel",
                        function (isConfirmed) {
                            if (isConfirmed) {
                                teamSettingsService.deleteTeam($scope.id, teamId)
                                    .then(function (result) {
                                        teamSettingsService.getTeams($scope.id).then(
                                            function (teamList) {
                                                if (teamList && teamList.length > 0) {
                                                    $state.go('main.apiSpace.chat2.settings.team', { teamId: teamList[0].id }, { reload: true });
                                                } else {
                                                    $state.go('main.apiSpace.chat2.settings', { pickedApiSpaceId: $stateParams.pickedApiSpaceId }, { reload: true });
                                                }

                                            }
                                        );
                                    })
                                    .catch(function (error) {
                                        growlService.danger("Team wasn't deleted due to: " + error.statusText);
                                    });
                            }
                        }
                    );
                };

                function getTeam(id, teamId) {
                    teamSettingsService.getTeam(id, teamId)
                        .then(processTeam)
                        .catch(processTeamErrors);
                }

                function getUsers(id) {
                    usersService.getUsers(id)
                        .then(processUsers)
                        .catch(processUsersError);
                }

                function processTeam(data) {
                    $scope.team = data;
                    $scope.select.teamName = data.name;
                    $scope.selected.members = [];
                    $scope.listOfMembers = '';

                    function isInUsers(member) {
                        return (_.findIndex($scope.users, function (el) {
                            return el.userName === member.username;
                        }) != -1);
                    }

                    if ($scope.team.members && $scope.team.members.length > 0) {
                        usersService.getUsers($scope.accountId).then(
                            function (data) {
                                processUsers(data);
                                $scope.team.members = $scope.team.members.filter(isInUsers);
                                $scope.team.members.forEach(function (member) {
                                    $scope.selected.members.push({
                                        username: member.username
                                    });
                                    if ($scope.listOfMembers.length === 0) {
                                        $scope.listOfMembers = member.username;
                                    } else {
                                        $scope.listOfMembers = $scope.listOfMembers + ', ' + member.username;
                                    }

                                });
                                $scope.$emit('MembersCountChange', {
                                    teamId: $scope.team.id,
                                    members: $scope.team.members
                                });
                            }

                        );

                    } else if (!$scope.team.members) {
                        $scope.team.members = [];
                        $scope.$emit('MembersCountChange', {
                            teamId: $scope.team.id,
                            members: $scope.team.members
                        });
                    } else {
                        $scope.$emit('MembersCountChange', {
                            teamId: $scope.team.id,
                            members: $scope.team.members
                        });
                    }


                    $scope.isTeamSelected = true;
                    var endOfMultiselect = angular.element('search-field');
                }

                function processUsers(data) {
                    $scope.users = data;
                    $scope.options = {
                        users: []
                    };
                    if ($scope.users) {
                        $scope.users.forEach(function (member) {
                            $scope.options.users.push({
                                username: member.userName
                            });
                        });
                    }

                }


                function processTeamErrors(error) {
                    growlService.danger("Team details data was not available, due to: " + error.statusText);
                }

                function processUsersError(error) {
                    growlService.danger("Users are not available, due to: " + error.statusText);
                }

                function addTeamMember(name) {
                    if (name) {
                        var data = {
                            username: name
                        };

                        return teamSettingsService.createTeamMember($scope.id, $scope.team.id, data)
                            .then(function onResolve(result) {
                                processTeam(result);
                            })
                            .catch(function (error) {
                                growlService.danger("Team member wasn't added due to: " + error.statusText);
                            });
                    }

                }

                function deleteTeamMember(username) {
                    if (username) {
                        return teamSettingsService.deleteTeamMember($scope.id, $scope.team.id, username)
                            .then(function (result) {
                                processTeam(result);
                            })
                            .catch(function (error) {
                                growlService.danger("Team member wasn't removed due to: " + error.statusText);

                            });
                    }
                }

                function disableEmail() {
                    teamSettingsService.deleteEmailConfig($scope.id, teamId)
                        .then(function (data) {
                            recalculateChannels();
                        })
                        .catch(function (error) {
                            growlService.danger("Email chat channel wasn't turned off due to: " + error.statusText);
                        });
                }
                function disableSms() {
                    teamSettingsService.deleteConfigSms($scope.id, teamId)
                        .then(function () {
                            recalculateChannels();
                        })
                        .catch(function (error) {
                            growlService.danger("Sms channel wasn't turned off due to: " + error.statusText);
                        });
                }
                function disableAppMessaging() {
                    teamSettingsService.deleteAppMessagingConfig($scope.id, teamId)
                        .then(function (data) {
                            recalculateChannels();
                        })
                        .catch(function (error) {
                            growlService.danger("Messaging app chat channel wasn't turned off due to: " + error.statusText);
                        });
                }

                function disableTwitter() {
                    teamSettingsService.deleteConfigTwitter($scope.id, teamId)
                        .then(function (data) {
                            recalculateChannels();
                        })
                        .catch(function (error) {
                            growlService.danger("Twitter chat channel wasn't turned off due to: " + error.statusText);
                        });
                }

                function disableFb() {
                    teamSettingsService.deleteConfigFb($scope.id, teamId)
                        .then(function (data) {
                            recalculateChannels();
                        })
                        .catch(function (error) {
                            growlService.danger("Facebook Messenger chat channel wasn't turned off due to: " + error.statusText);
                        });
                }

                function disableRcs() {
                    teamSettingsService.deleteRcsConfig($scope.id, teamId)
                        .then(function (data) {
                            recalculateChannels();
                        })
                        .catch(function (error) {
                            growlService.danger("Rcs chat channel wasn't turned off due to: " + error.statusText);
                        });
                }

                function disableWhatsApp() {
                    teamSettingsService.deleteWhatsAppConfig($scope.id, teamId)
                        .then(function (data) {
                            recalculateChannels();
                        })
                        .catch(function (error) {
                            growlService.danger("WhatsApp chat channel wasn't turned off due to: " + error.statusText);
                        });
                }

                function recalculateChannels() {
                    $scope.$emit('ChannelsCountChange', {
                        teamId: teamId
                    });
                }
                // for testing purposes
                $scope.getTeam = getTeam;

            }]);
})(window.angular);